import { Component } from '@angular/core';
import { StateService } from '@uirouter/angular';

@Component({
  selector: 'app-new-search-widget',
  template: `
    <app-dashboard-card title="New Search (Projects or Contract Awards)">
      <div class="new-search-actions">
        <button mat-stroked-button class="dashboard-action-button" (click)="goProjects()">Projects</button>
        <button mat-stroked-button class="dashboard-action-button" (click)="goContracts()">Contract Awards</button>
      </div>
    </app-dashboard-card>
  `,
  styles: [
    `.new-search-actions { display: flex; align-items: center; gap: 8px; flex-wrap: nowrap; }`,
    `.new-search-actions .mdc-button { white-space: nowrap; }`,
    `.dashboard-action-button { border-color: var(--mat-sys-outline, var(--sys-outline)); color: var(--mat-sys-on-surface, var(--sys-on-surface)); }`,
    `.dashboard-action-button:hover { background: var(--mat-sys-surface-container-highest, var(--sys-surface-container-highest)); color: var(--mat-sys-on-surface, var(--sys-on-surface)); }`
  ]
})
export class NewSearchWidgetComponent {
  constructor(private readonly stateService: StateService) { }

  goProjects(): void {
    this.stateService.go('search.forProjects');
  }

  goContracts(): void {
    this.stateService.go('search.forContractAwards');
  }
}
